import Cookies from 'js-cookie';
import jwtDecode from 'jwt-decode';
import { isMobile, isTablet } from 'react-device-detect';

import config from '../../config';
import { EMAIL_LISTS } from '../../constants';

import { useUserStore } from '../../stores/user';

import { User, Session } from '../../types';
import { isEmpty } from '../../utils';

import { getApiKeyClient } from '../client/http';

import { identifyUserLR } from '../logrocketService';
import { getUserData } from './auth';
import { subscribeContact } from './emails';
import { getUserEvents } from './events';

const INCORRECT_CRED_MESSAGES = [
  'User does not exist',
  'Password hashes do not match',
];

const {
  apiBaseUrl: { sessions: baseUrl },
} = config;
const apiClient = () => getApiKeyClient(baseUrl);

export const getSessionFromToken = async (
  token: string,
): Promise<Session | null> => {
  if (!token) return null;

  try {
    return jwtDecode<Session>(token);
  } catch (e) {
    return null;
  }
};

export const signIn = async (
  email: string,
  password: string,
  isKeepSignIn: boolean,
) => {
  const newSession = {
    email,
    password,
    remember: isKeepSignIn,
    origin: 'sessions.au.crowdclip.co',
    service: 'sessions.au',
  };

  try {
    const response = await apiClient().post(`/api/sign-in`, newSession);

    const accessToken = response.data.result.accessToken;
    const session = jwtDecode<Session>(accessToken);
    const userData = await getUserData(session.userId);

    const user: User = { ...userData, session };

    identifyUserLR(user);

    Cookies.set('token', response.data.result.refreshToken);
    useUserStore.setState((state) => ({ ...state, user, accessToken }));
    if (isKeepSignIn) {
      useUserStore.getState().saveAccessToken();
    }

    // add user to sendgrid list – if mobile and has no events
    if (isMobile || isTablet) {
      const userEvents = await getUserEvents(session.userId);

      if (isEmpty(userEvents))
        await subscribeContact(EMAIL_LISTS.MOBILE_SIGN_IN, user);
    }

    return user;
  } catch (error: any) {
    const message = error.response?.data?.message;
    if (INCORRECT_CRED_MESSAGES.includes(message)) {
      error.errMsg =
        'Incorrect credentials provided. Ensure both email and password are correct';
    }

    throw error;
  }
};
